import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'
import { VirtualKeyboardComponent } from './virtual-keyboard.component'
import { VirtualKeyboardDirective } from './virtual-keyboard.directive'

/**
 * Teclado virtual do totem: o componente é renderizado uma vez no container do
 * autoatendimento e a diretiva liga cada campo digitável a ele.
 */
@NgModule({
  declarations: [VirtualKeyboardComponent, VirtualKeyboardDirective],
  imports: [CommonModule],
  exports: [VirtualKeyboardComponent, VirtualKeyboardDirective],
})
export class VirtualKeyboardModule {}
